module.exports = __webpack_public_path__ + "img/GQ.d8f2262e.png";